// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"07f15c7c","433":"04252231","582":"cd387fce"}[chunkId] + ".chunk.css";
};